import React, { useRef, useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { clearErrors, getAllProductsHome } from '../actions/productAction'
import { useSelector, useDispatch } from 'react-redux'
import { Swiper, SwiperSlide } from 'swiper/react'
import { useAlert } from 'react-alert'

import {
  EffectFade,
  Autoplay,
  Navigation,
  Pagination,
  FreeMode,
  Thumbs,
} from 'swiper'

const Acca = () => {
  const alert = useAlert()
  const dispatch = useDispatch()
  const { loading, error, products } = useSelector((state) => state.products)
  useEffect(() => {
    if (error) {
      alert.error(error)
      dispatch(clearErrors())
    }
    dispatch(getAllProductsHome())
  }, [dispatch, error, alert])

  return (
    <>
      {/*<!-- Page Banner Section Start -->*/}
      <div
        className='section page-banner-section'
        style={{ backgroundImage: 'url(../assets/images/banner.jpg)' }}
      >
        <div className='overlayBanner'></div>
        <div className='container'>
          {/*<!-- Page Banner Content End -->*/}
          <div className='page-banner-content'>
            <h2 className='title'>Acca</h2>

            <ul className='breadcrumb'>
              <li>
                <Link to='/'>Home</Link>
              </li>
              <li className='active'>Acca</li>
            </ul>
          </div>
          {/*<!-- Page Banner Content End -->*/}
        </div>
      </div>
      {/*<!-- Page Banner Section End -->*/}

      {/*<!-- New Product Section Start -->*/}
      <div className='section section-padding'>
        <div className='container'>
          {/*<!-- Product Section Wrapper Start -->*/}
          <div className='product-section-wrapper courseSecPanel'>
            <div className='row justify-content-center'>
              <div className='col-lg-12'>
                {/*<!-- Product Wrapper Start -->*/}
                <div className='product-wrapper product-active'>
                  {/*<!-- Product Top Wrapper Start -->*/}
                  <div className='product-top-wrapper'>
                    {/*<!-- Section Title Start -->*/}
                    <div className='section-title order-md-1'>
                      <h6>ACCA COURSES</h6>
                      <h2 className='title'>Applied Knowledge</h2>
                    </div>
                    {/*<!-- Section Title End -->*/}
                  </div>
                  {/*<!-- Product Top Wrapper End -->*/}

                  {/*<!-- Product Tabs Content Start -->*/}
                  <div className='courseSec col-lg-8 col-12 m-auto'>
                    <div className='row'>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>BT</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Business Technology</span> Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>FA</Link>
                            </h4>
                            <div className='d-flex align-items-center justify-content-center'>
                              <p>
                                <span>Financial Accounting</span> Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>MA</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Management Accounting</span> Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                    </div>
                  </div>
                  {/*<!-- Product Tabs Content End -->*/}
                </div>
                {/*<!-- Product Wrapper End -->*/}
              </div>
              <div className='col-lg-12'>
                {/*<!-- Product Wrapper Start -->*/}
                <div className='product-wrapper product-active'>
                  {/*<!-- Product Top Wrapper Start -->*/}
                  <div className='product-top-wrapper'>
                    {/*<!-- Section Title Start -->*/}
                    <div className='section-title order-md-1'>
                      <h6>ACCA COURSES</h6>
                      <h2 className='title'>Applied Skills</h2>
                    </div>
                    {/*<!-- Section Title End -->*/}
                  </div>
                  {/*<!-- Product Top Wrapper End -->*/}

                  {/*<!-- Product Tabs Content Start -->*/}
                  <div className='courseSec col-lg-8 col-12 m-auto'>
                    <div className='row'>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>PM</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Performance Management</span> Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>TX</Link>
                            </h4>
                            <div className='d-flex align-items-center justify-content-center'>
                              <p>
                                <span>Taxation – UK variant</span> Recordings
                                with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>Recordings</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>FR</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Financial Reporting</span> Recordings with
                                Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>AA</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Audit & Assurance</span> Recordings with
                                Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>FM</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Financial Management</span> Recordings
                                with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>LW</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Corporate & Business Law</span> Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                    </div>
                  </div>
                  {/*<!-- Product Tabs Content End -->*/}
                </div>
                {/*<!-- Product Wrapper End -->*/}
              </div>
              <div className='col-lg-12'>
                {/*<!-- Product Wrapper Start -->*/}
                <div className='product-wrapper product-active'>
                  {/*<!-- Product Top Wrapper Start -->*/}
                  <div className='product-top-wrapper'>
                    {/*<!-- Section Title Start -->*/}
                    <div className='section-title order-md-1'>
                      <h6>ACCA COURSES</h6>
                      <h2 className='title'>Strategic Professionals</h2>
                    </div>
                    {/*<!-- Section Title End -->*/}
                  </div>
                  {/*<!-- Product Top Wrapper End -->*/}

                  {/*<!-- Product Tabs Content Start -->*/}
                  <div className='courseSec col-lg-8 col-12 m-auto'>
                    <div className='row'>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>SBL</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Strategic Business Leader</span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>SBR</Link>
                            </h4>
                            <div className='d-flex align-items-center justify-content-center'>
                              <p>
                                <span>Strategic Business Reporting</span>{' '}
                                Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                      <div className='col-4'>
                        {/*<!-- Single Product Start -->*/}
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <Link to={`/product/`}>AFM</Link>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Advanced Financial Management</span>{' '}
                                Recordings
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <Link className='action' to={`/product/`}>
                                <span>See Details</span>
                              </Link>
                            </li>
                          </ul>
                        </div>
                        {/*<!-- Single Product End -->*/}
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>APM</a>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Advanced Performance Management</span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>ATX</a>
                            </h4>
                            <div className='d-flex align-items-center justify-content-center'>
                              <p>
                                <span>Advanced Taxation – UK variant</span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className='col-4'>
                        <div className='single-product'>
                          <div className='product-content'>
                            <h4 className='title'>
                              <a href='/product/'>AAA</a>
                            </h4>
                            <div className=''>
                              <p>
                                <span>Advanced Audit and Assurance</span>{' '}
                                Recordings with Live Session Support
                              </p>
                            </div>
                          </div>
                          <ul className='product-meta'>
                            <li>
                              <a className='action' href='/product/'>
                                <span>See Details</span>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/*<!-- Product Tabs Content End -->*/}
                </div>
                {/*<!-- Product Wrapper End -->*/}
              </div>
            </div>
          </div>
          {/*<!-- Product Section Wrapper End -->*/}
        </div>
      </div>
      {/*<!-- New Product Section End -->*/}
    </>
  )
}

export default Acca
